import { GetterTree } from 'vuex';
import { DocumentSignState } from './state';
import { RootState } from '../types';


const getters: GetterTree<DocumentSignState, RootState> = {
    verificationStatus: state => state.verificationStatus,
};

export default getters;